import { useTranslation } from "react-i18next";

export default function ComparisonLoading() {
  const { t } = useTranslation("common");

  return (
    <div className="grid place-items-center">
      <p>{t("common:loading")}</p>
    </div>
  );
}
